import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import Text from '../../Text/Text';
//@ts-ignore
import styles from './Trigger.module.scss';

interface Props {
	title: string;
	description?: string;
	isExpanded?: boolean;
}

const TableTrigger: React.FC<Props> = ({
	title,
	description,
	isExpanded = false,
}) => (
	<div className={styles.wrapper}>
		<div className={styles.details}>
			<Text tx={title} firstUpper className={styles.title} />
			{description && (
				<Text tx={description} firstUpper className={styles.description} />
			)}
		</div>
		<div className={styles.toggler}>
			<Text
				tx={isExpanded ? 'base.hide' : 'base.show'}
				firstUpper
				className={styles.toggleText}
			/>
			<FontAwesomeIcon icon={isExpanded ? faAngleUp : faAngleDown} size='2xs' />
		</div>
	</div>
);

export default TableTrigger;
